const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '实时爆料更新',
    desc: '7x24小时不间断更新，第一时间推送最新娱乐八卦小道消息，让你永远快人一步吃到新鲜瓜。',
  },
  {
    id: 2,
    icon: 'ri-shield-user-line',
    title: '匿名爆料保护',
    desc: '严格保护爆料者隐私，多层加密技术确保你的身份信息绝不外泄，放心分享你所知道的。',
  },
  {
    id: 3,
    icon: 'ri-check-double-line',
    title: '多方交叉验证',
    desc: '专业审核团队+社区举报机制双重把关，拒绝虚假信息传播，力求每一条爆料都有据可查。',
  },
  {
    id: 4,
    icon: 'ri-global-line',
    title: '多元话题覆盖',
    desc: '从娱乐圈到网红圈，从综艺到影视，十余个话题板块全覆盖，总有一个是你感兴趣的瓜田。',
  },
  {
    id: 5,
    icon: 'ri-group-line',
    title: '活跃瓜友社区',
    desc: '200万+活跃用户每日产出海量优质讨论，热评不断、观点交锋，吃瓜也能吃出深度和乐趣。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              为什么选择我们
            </h2>
            <p className="text-sm text-foreground-500">
              五大平台特色，打造全网最优质的吃瓜交流社区
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {features.map((f) => (
              <div
                key={f.id}
                className="bg-background-50 rounded-xl p-6 text-center hover:bg-background-50 hover:-translate-y-1 transition-all duration-300 border border-background-200/50"
              >
                <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className={`${f.icon} text-xl text-primary-500`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-2">{f.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}